import { Button } from "primereact/button";
import React, { useEffect, useState, useRef, useContext } from "react";
import TextInput from "./TextInput";
import { TabPanel, TabView } from "primereact/tabview";
import { Dialog } from "primereact/dialog";
import { eventService } from "../services/EventService";
import { ProgressSpinner } from "primereact/progressspinner";
import ScreenLoader from "./ScreenLoader";
import { Dropdown } from "primereact/dropdown";
import { AppDB } from "../App";
import { Checkbox } from "primereact/checkbox";
import { InputNumber } from "primereact/inputnumber";
import { lookupsService } from "../services/LookupsService";
export default function AddEventRegister({
	registerType = null,
	selectedeventsPergroup,
	events,
	show = false,
	setShow,
	form,
	setForm,
	onSubmit,
	setfetchReportLoader,
	fetchReportLoader
}) {
	const [isLoading, setisLoading] = useState(false);
	const [eventRegisterTypes, setEventRegisterTypes] = useState([{}]);

	const { lookUp, toast } = useContext(AppDB);
	const [selectedRegisterType, setselectedRegisterType] = useState(null);
	const [delimitationTyepes] = useState([
		{
			id: 1,
			name: "National"
		},
		{
			id: 2,
			name: "Local"
		}
	]);
	const [delimitationTyepe, setDelimitationTyepes] = useState(1);

	useEffect(() => {
		if (lookUp && lookUp.voterRegisterTypes) {
			setEventRegisterTypes(lookUp.voterRegisterTypes);
		}
		if (selectedeventsPergroup?.name) {
			setForm((prev) => ({ ...prev, eventID: selectedeventsPergroup?.eventID}));
		}
		else 
		{
			setForm((form) => ({...form, isNationalDelimitation:true}))
		}
	}, [lookUp, selectedeventsPergroup]);

	var [sortOptions, setSortOptions] = useState([
		{
			Name: "Surname",
			Value: "Surname"
		},
		{
			Name: "Firstname",
			Value: "Firstname"
		},
		{
			Name: "ID Number",
			Value: "IDNumber"
		},
		{
			Name: "Registration Number",
			Value: "RegistrationNumber"
		}
	]);
	const [pollingStationForm, setPollingStationForm] = useState(form.config);

	const [errors, setErrors] = useState({});

	async function SubmitForm() {
		let newForm = { ...form };
		let newErrors = {};

		if (!newForm.name) newErrors.name = "Register Name is required";
		if (!newForm.description) newErrors.description = "Description is required";
		if (!newForm.voterRegisterTypeID) newErrors.voterRegisterTypeID = "Register Type is required";

		setErrors(newErrors);

		if (Object.keys(newErrors).length === 0) {
			const registerForm = {
			...form,
			config: { ...pollingStationForm },
			};

			onSubmit(registerForm);
			setfetchReportLoader(true);
		}
	}

	const handleVoteRegister = (data) => {
		setForm({ ...form, voterRegisterTypeID: data.id });
	};
	return (
		<Dialog
			draggable={false}
			header={
				<>
					<li className="pi pi-plus"> </li>
					<span> Add Register</span>
				</>
			}
			footer={
				<>
					<Button label="Close" onClick={() => setShow(false)} className="p-button-danger" />
					<Button label="Submit" onClick={SubmitForm} className="p-button-success" />
				</>
			}
			visible={show}
			onHide={(e) => {
				setShow(false);
			}}
			style={{ width: "75%", height: "50%" }}
		>
			<ScreenLoader visible={isLoading} />
			<div className="grid card mt-4 mb-2">
				<div className="col-12 lg:col-12">
					<div className="grid">
						{registerType && registerType.id == 1 && (
							<div className="col-12  lg:col-6">
								<label>Event Name</label>
								<TextInput style={{ fontWeight: "bold" }} value={selectedeventsPergroup?.name} disabled />
							</div>
						)}

						{registerType && registerType.id == 2 && (
							<div className="col-12  lg:col-6">
								<label>Register Type</label>
								<TextInput style={{ fontWeight: "bold" }} value={registerType?.name} disabled />
							</div>
						)}

						<div className="col-12  lg:col-6">
							<label>
								Register Name <span style={{ color: "red" }}>*</span>
							</label>
							<TextInput value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />

							{errors.name && <p className="p-error">{errors.name}</p>}
						</div>

						<div className="col-12  lg:col-6">
							<label>
								Description <span style={{ color: "red" }}>*</span>
							</label>
							<TextInput value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} />
							{errors.description && <p className="p-error">{errors.description}</p>}
						</div>
						{registerType && registerType.id == 2 && (
							<div className="col-12  lg:col-6">
								<label>
									Demarcation Type <span style={{ color: "red" }}>*</span>
								</label>
								<Dropdown
									value={delimitationTyepe}
									optionValue="id"
									optionLabel="name"
									style={{ width: "100%" }}
									options={delimitationTyepes} // Ensure it's always an array
									onChange={(e) => {
										setForm((form) => ({...form, isNationalDelimitation:e.value == 1}))
										setDelimitationTyepes(e.value);
									}}
									placeholder="Select a Demarcation Type"
								/>
								{/* {errors.voterRegisterTypeID && <p className="p-error">{errors.voterRegisterTypeID}</p>} */}
							</div>
						)}
						<div className="col-12  lg:col-6">
							<label>
								Voter Register Type <span style={{ color: "red" }}>*</span>
							</label>
							<Dropdown
								value={selectedRegisterType}
								style={{ width: "100%" }}
								options={eventRegisterTypes || []} // Ensure it's always an array
								onChange={(e) => {
									handleVoteRegister(e.target.value);
									setselectedRegisterType(e.target.value);
								}}
								optionLabel="name" // Adjust if the property name is different
								placeholder="Select a Register"
							/>
							{errors.voterRegisterTypeID && <p className="p-error">{errors.voterRegisterTypeID}</p>}
						</div>
						
						{form?.voterRegisterTypeID && form.voterRegisterTypeID == 2 && (
							<>
								<div className="col-12  lg:col-4">
									<label>Electors Per Station</label>
									<InputNumber
										style={{ width: "100%" }}
										value={pollingStationForm.electorsPerPollingStation}
										onValueChange={(e) => 
											setPollingStationForm((preForm) => ({ ...preForm, electorsPerPollingStation: e.target.value }))
										}
									/>
								</div>

								{/* <div className="col-12  lg:col-4">
									<label>Sort By</label>
									<Dropdown
										style={{ width: "100%" }}
										optionLabel="Name"
										optionValue="Value"
										onChange={(e) => setPollingStationForm((preForm) => ({ ...preForm, sortField: e.target.value }))}
										options={sortOptions}
										value={pollingStationForm.sortField}
										placeholder="Sort Field"
									/>
								</div> */}
								{/* <div className="col-12  lg:col-4">
									<label>Sort Ascending</label>
									<Checkbox
										style={{ width: "100%" }}
										checked={pollingStationForm.sortOrderAscending}
										onChange={(e) => setPollingStationForm((preForm) => ({ ...preForm, sortOrderAscending: e.target.checked }))}
									/>
								</div> */}
								<div className="col-12  lg:col-4">
									<label>Recreate Polling Stations</label>
									<Checkbox
										style={{ width: "100%" }}
										checked={pollingStationForm.recreate}
										onChange={(e) => setPollingStationForm((preForm) => ({ ...preForm, recreate: e.target.checked }))}
									/>
								</div>
								<div className="col-12  lg:col-4">
									<label>Distribute Remainder</label>
									<Checkbox
										style={{ width: "100%" }}
										checked={pollingStationForm.distributeRemainder}
										onChange={(e) => setPollingStationForm((preForm) => ({ ...preForm, distributeRemainder: e.target.checked }))}
									/>
								</div>
							</>
						)}
					</div>
				</div>
			</div>
		</Dialog>
	);
}
